export class BrowserWindow
{
	public static getScrollX():number
	{
		return window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0;
	}

	public static getScrollY():number
	{
		return window.pageYOffset || document.documentElement.scrollTop  || document.body.scrollTop  || 0;
	}

	public static getURLPathWithoutQuery()
	{
		var url = location.protocol + "//" + location.host + location.pathname;
		return url;
	}
}